<button
    class="close-icon"
    i18n-aria-label="@@hermes.accessibility.close"
    aria-label="Close"
    (click)="handleButtonClicked()"
    hIconButton
    [color]="appearance()"
    [iconSize]="iconSvgSize()"
    [radius]="radius()"
    [iconName]="iconName"
    [variant]="variant()"
    [id]="'close-button-id'"
    [name]="'close-button'">
</button>
